import { CASE_TYPES_FETCH_FAILURE, CASE_TYPES_FETCH_REQUEST, CASE_TYPES_FETCH_SUCCESS } from '../actions/xerCaseType';

const initialState: ICaseTypeStore = {
  currentCaseType: null,
  caseTypes: null,
  isFetching: false,
  error: null,
};

export default function caseType(state: ICaseTypeStore = initialState, action: any): ICaseTypeStore {
  switch (action.type) {
    case CASE_TYPES_FETCH_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        caseTypes: null,
        error: null,
      });
    case CASE_TYPES_FETCH_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        caseTypes: action.response,
        error: null,
      });
    case CASE_TYPES_FETCH_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        caseTypes: null,
        error: action.error,
      });
    default:
      return state;
  }
}
